import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import "./PanVerify.css";

export default function PanVerify(){

  const user = JSON.parse(localStorage.getItem("user"));
  const [pan,setPan] = useState("");
  const [history,setHistory] = useState([]);

  const searchPan = async()=>{

    if(!pan){
      Swal.fire("Enter PAN Number");
      return;
    }

    Swal.showLoading();

    const res = await fetch("https://rcfinder.online/api/pan_verify.php",{
      method:"POST",
      headers:{ "Content-Type":"application/json" },
      body:JSON.stringify({
        user_id:user.id,
        pan
      })
    });

    const data = await res.json();
    Swal.close();

    if(data.status === "wallet_low"){
      Swal.fire("Wallet Low","Recharge Required","warning");
    }
    else if(data.status === "failed"){
      Swal.fire("Failed",data.message,"error");
    }
    else{

      Swal.fire({
        icon:"success",
        title:"PAN Verified",
        html:`
          <b>PAN:</b> ${data.pan}<br>
          <b>Name:</b> ${data.name}<br>
          <b>Father:</b> ${data.father}<br>
          <b>DOB:</b> ${data.dob}<br>
          <b>Gender:</b> ${data.gender}
        `
      });

      setHistory(prev => [
        data,
        ...prev
      ]);
    }
  };


  return(
    <div className="pan-wrapper">

      <h2 className="pan-title">PAN Verify</h2>

      <div className="pan-box">

        <input 
          type="text"
          placeholder="Enter PAN Number"
          value={pan}
          onChange={e=>setPan(e.target.value.toUpperCase())}
        />

        <button onClick={searchPan}>
          Verify PAN (₹35)
        </button>

      </div>


      {/* HISTORY */}
      <div className="pan-history">

        <h3>History</h3>

        {history.length === 0 ? (
          <p>No history yet</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>PAN</th>
                <th>Name</th>
                <th>Father</th>
                <th>DOB</th>
                <th>Gender</th>
              </tr>
            </thead>

            <tbody>
              {history.map((h,i)=>(
                <tr key={i}>
                  <td>{h.pan}</td>
                  <td>{h.name}</td>
                  <td>{h.father}</td>
                  <td>{h.dob}</td>
                  <td>{h.gender}</td>
                </tr>
              ))}
            </tbody>

          </table>
        )}

      </div>

    </div>
  );
}
